u.TabSelect = class extends u.ForElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        this._click = () => {
            this.selectTab();

            window.location.hash = this.getAttribute('data-hash');
        };
    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('click', this._click);
        u.TabSelect.items.push(this); // add each tab to the set of tab-select elements
    }

    detachedCallback() {
        /**
         *
         */
        this.removeEventListener('click', this._click);        
    }

    selectTab() {
        // style all tabs as inactive
        const tabSet = this.getAttribute('u-for');
        const numTabs = this.firstElementChild.parentNode.parentNode.children.length; 
        for (var i = 0; i< u.TabSelect.items.length; i++) {
            if (u.TabSelect.items[i].getAttribute('u-for') === tabSet) {
                u.TabSelect.items[i].firstElementChild.classList.remove(u.TabSelect.activeStyle);
            }
        }

        // style active tab
        // BASE-3829 - remove details tab when no content
        if(numTabs>1){
            this.firstElementChild.classList.add(u.TabSelect.activeStyle);
            const val = this.getAttribute('u-to');
            this.$forElement.$moveTo(val);
        }
    }
};

u.TabSelect.items = [];
u.TabSelect.activeStyle = 'c-details-body__tab--active';  // TODO this should be more dynamic
u.TabSelect.register('u-tab-select');

$(document).ready(function() {
    // we want to support permalink for the details page. Depends on the hash,
    // we highlight the right one but this must be done on Dom Ready
    const hash = window.location.hash;
    for(let item of u.TabSelect.items) {
        if (item.getAttribute('data-hash') === hash) {
            item.selectTab();
        }
    }
});

